import axios from 'axios'
import { post, get, put, appDelete, jsonPost, uploadFilePost, IP } from './public'
import store from '../store/index'
/**
 * @列表
 */
export const roleList = params => {
  return get('/sys/role/list', params);
};


export const fileUrl = process.env.VUE_APP_API_URL + '/file/upload'
// 文件上传
export const upload = params => {
  return jsonPost('/file/upload', params);
};

// 查询推荐商品
export const recommend = params => {
  return get('/front/recommend', params);
};
// 广告查询
export const advertising = params => {
  return get('/front/advertising', params);
};
// 首页品牌
export const brand = params => {
  return jsonPost('/front/brand', params);
};
// 专区推荐查询
export const special = params => {
  return get('/front/special', params);
};

// 分页查询品牌列表
export const brandList = params => {
  return get('/brand/list', { pageSize: 9999 });
};
// 根据商品查询商品所在的组合商品
export const groupsById = params => {
  return get('/front/groupsById', params);
};

export const login = function (params) {
  return jsonPost('/sys/login', params)
}
// 手机号登录接口
export function phoneLogin(parameter) {
  return jsonPost('/sys/phoneLogin', params)
}


// 校验用户手机号是否唯一
export const checkTelphone = function (params) {
  return get('/res/checkTelphone', params)
}
// 校验验证码是否正确
export const checkCode = function (params) {
  return get('/res/checkCode', params)
}
// 校验用户邮箱是否唯一
export const checkEmail = function (params) {
  return get('/res/checkEmail', params)
}
// 校验用户账号是否唯一
export const checkUsername = function (params) {
  return get('/res/checkUsername', params)
}
// 获取验证码
export const getCheckCode = function (params) {
  return get('/res/getCheckCode', params)
}
// 用户注册
export const register = function (params) {
  return jsonPost('/res/register', params)
}

// 查询所有在用分类
export const categoryTree = params => {
  return get('/front/category', params)
};
// 查询分类商品数量
export const getCommodityNum = params => {
  return get('/front/getCommodityNum', params)
};

// 查询商品
export const goodsList = params => {
  return jsonPost('/front/commodity', params)
};
// 根据广告查询商品
export const commodityByAdvertising = params => {
  return jsonPost('/front/commodityByAdvertising', params)
};
// 查询品牌商品分类
export const categoryByBrand = params => {
  return get('/front/categoryByBrand', params)
};
// 查询专区商品分类
export const categoryBySpecial = params => {
  return get('/front/categoryBySpecial', params)
};
// 根据专区查询商品
export const commodityBySpecial = params => {
  return jsonPost('/front/commodityBySpecial', params)
};
// 查询三级分类标签
export const categoryLabel = params => {
  return get('/front/categoryLabel', params)
};
// 查询价格区间商品数量
export const getCommoditySectionCount = params => {
  return jsonPost('/front/getCommoditySectionCount', params)
};

// 查询同一组商品
// 商品详情查询
export const commodityGroup = params => {
  return get('/front/details', params)
};

// 添加我的关注
export const myAttentionAdd = params => {
  return get('/myAttention/add', params)
};
// 购物车添加商品
export const cartAdd = params => {
  const res = jsonPost('/cart/add', params)
  res.then(() => {
    cartList({ params });
  })
  return res;
};

// 分页查询购物车商品列表
export const cartList = params => {
  const res = jsonPost('/cart/list', params);
  res.then(res => {
    store.commit("SET_CART_DATA", res.result.records.length || 0);
  })
  return res;
};
// 购物车编辑商品
export const cartEdit = params => {
  return jsonPost('/cart/edit', params)
};
// 删除购物车商品
export const cartDelete = params => {
  const res = appDelete('/cart/delete', params)
  res.then(r => {
    getCount().then(resp => {
      const count = resp.result
      store.commit("SET_CART_DATA", count);
    })
  })
  return res
};
// 批量删除购物车商品
export const cartDeleteBatch = params => {
  const res = jsonPost('/cart/deleteBatch', params)
  res.then(r => {
    getCount().then(resp => {
      const count = resp.result
      store.commit("SET_CART_DATA", count);
    })
  })
  return res
};
// 移到我的关注
export const toMyAttention = params => {
  const res = get('/cart/toMyAttention', params)
  res.then(r => {
    getCount().then(resp => {
      const count = resp.result
      store.commit("SET_CART_DATA", count);
    })
  })
  return res
};
// 批量移到我的关注
export const toMyAttentionBatch = params => {
  const res = jsonPost('/cart/toMyAttentionBatch', params)
  res.then(r => {
    getCount().then(resp => {
      const count = resp.result
      store.commit("SET_CART_DATA", count);
    })
  })
  return res
};
// 分页查询我的关注
export const getAttentionList = params => {
  return jsonPost('/myAttention/list', params)
};
// 分页查询我的浏览记录
export const getBrowseList = params => {
  return jsonPost('/myBrowse/list', params)
};
// 从浏览记录移到我的关注
export const browseToMyAttention = params => {
  return get('/myBrowse/toMyAttention', params)
};
// 删除我的关注
export const deleteMyAttention = params => {
  return appDelete('/myAttention/delete', params)
};
// 删除我的浏览记录
export const deleteMyBrowse = params => {
  return appDelete('/myBrowse/delete', params)
};

// 导出EXCEL
export const exportExcel = params => {
  var link = document.createElement('a');
  link.style.display = 'none';
  //设置下载路径
  link.href = `${axios.defaults.baseURL}/cart/exportExcel?userId=${params.userId}`;
  for (let key in params) {
    if (key != "userId") link.href += `&${key}=${params[key]}`
  }
  //触发点击
  link.click();
};
// 加入PPT
export const exportPPT = params => {
  var link = document.createElement('a');
  link.style.display = 'none';
  //设置下载路径
  link.href = `${axios.defaults.baseURL}/cart/exportPPT?userId=${params.userId}`;
  for (let key in params) {
    if (key != "userId") link.href += `&${key}=${params[key]}`
  }
  //触发点击
  link.click();
};

// 收货地址
// 新增
export const addressAdd = params => {
  return jsonPost('/receiverAddress/add', params)
};
// 分页列表查询
export const addressList = params => {
  return jsonPost('/receiverAddress/list', params)
};
// 编辑
export const receiverAddressEdit = params => {
  return jsonPost('/receiverAddress/edit', params)
};
// 修改默认
export const modifyDefaultAddress = params => {
  return jsonPost('/receiverAddress/modifyDefaultAddress', params)
};
// 删除地址
export const deleteReceiverAddress = params => {
  return appDelete('/receiverAddress/deleteReceiverAddress', params)
};

// 订单
// 新增
export const addOrder = params => {
  return jsonPost('/order/add', params)
};
// 分页列表查询
export const orderList = params => {
  return jsonPost('/order/queryPageListFront', params)
};
//查询子账号待审核订单
export const orderAuditList = params => {
  return jsonPost('/order/queryListAuditFront', params)
};
// 主账号审核订单
export const orderAudit = params => {
  return get('/order/orderAudit', params)
};

// 根据缺货商品Id查询已推荐商品
export const findCommodityRecommendCommodityId = params => {
  return get('/order/findCommodityRecommendCommodityId', params)
};
// 删除缺货商品并替换推荐商品
export const addCommodityRecommendToCommodityOrder = params => {
  return jsonPost('/commodityRecommend/addCommodityRecommendToCommodityOrder', params)
};
// 删除缺货商品
export const deleteCommodityRecommend = params => {
  return appDelete('/commodityRecommend/deleteCommodityRecommend', params)
};
// 根据订单信息查询商品详情
export const findSysCommodityOrderByOrderId = params => {
  return get('/order/findSysCommodityOrderByOrderId', params)
};
export const findSysCommodityOrderByOrderIdForUser = params => {
  return get('/order/findSysCommodityOrderByOrderIdForUser', params)
};

// 取消订单
export const cancelOrder = params => {
  return jsonPost('/order/deleteOrderInformation', params)
}

export const findBillCustomerByOrderId = params => {
  return jsonPost('/bill/findBillCustomerByOrderId', params)
};

export const buyAgain = params => {
  return get('/order/buyAgain', params)
};
// 订单详情
export const findOrderInformationById = params => {
  return get('/order/findOrderInformationById', params)
};
// 查询凭证(物流/发票)
export const findLogisticsOrder = params => {
  return jsonPost('/order/findLogisticsOrder', params)
};
// 根据订单ID查询里程碑
export const findMilepostByOrderId = params => {
  return get('/milepost/findMilepostByOrderId', params)
};
// 提交
export const submission = params => {
  return put('/order/userSubmission', params)
};

// 通过id查询用户
export const queryById = params => {
  return get('/sys/user/queryById', params)
};
// 忘记密码验证
export const updatePassword = params => {
  return jsonPost('/res/updatePassword', params)
};
// 修改密码
export const modifyPassword = params => {
  return put('/sys/user/updatePassword', params)
};
// 新增用户
export const userAdd = params => {
  return jsonPost('/sys/user/add', params)
};
// 查询用户子账号
export const queryChildren = params => {
  return get('/sys/user/queryChildren', params)
};
// 编辑用户
export const userEdit = params => {
  return jsonPost('/sys/user/edit', params)
};
// 删除用户
export const userDelete = params => {
  return appDelete('/sys/user/delete', params)
};
// 重置密码
export const resetPassword = params => {
  return put('/sys/user/resetPassword', params)
};
// 启用&禁用用户
export const frozen = params => {
  return put('/sys/user/frozen', params)
};
// 修改企业会员授信额度
export const beforehandLimit = params => {
  return put('/sys/user/beforehandLimit', params)
};
// 获取业务员的客户
export const getUsersBySalesman = params => {
  return get('/sys/user/getUsersBySalesman', params)
};

// 获取简介
export const introList = params => {
  return get('/front/introList', params)
};

export const intro = params => {
  return get('/front/intro', params)
};

// 简介图标查询
export const introAll = systemCode => get('/front/introAll', {systemCode})


// 新增意见反馈
export const adviceAdd = params => {
  return jsonPost('/advice/add', params)
};

// 移到我的关注
export const getCount = params => {
  return get('/cart/getCount', params)
};

// 推荐列表
export const recomends = params => {
  return jsonPost('/front/recommendList', params)
};

//推荐列表
export const recom=params=>{

  return jsonPost('/front/schemeList', params)
}

// 根据推荐专区查询方案
export const commodityByRecomend = params => {
  return jsonPost('/front/schemeList', params)
};

// 根据推荐方案查询商品
export const commodityByRecomendId = params => {
  return jsonPost('/front/commodity/list', params)
};
